export default {
    driver_performance_riskTab_caseUpdatedCorrectly: "Case updated correctly",
    driver_performance_riskTab_errorOccurredWhileUpdatingTheCase: "An error occurred while updating the case.",
    driver_performance_riskTab_commentSavedSuccessfully: "Comment saved successfully",
    driver_performance_riskTab_errorOccurredWhileCreatingTheComments: "An error occurred while creating the comments",
    driver_performance_riskTab_noEventsFound: "No events found",
    driver_performance_riskTab_eventMarkedAsRead: "Event marked as read",
    driver_performance_riskTab_noVideoDataAvailableForThisEvent: "No video data available for this event",
    driver_performance_riskTab_omit: "Omit",
    driver_performance_riskTab_eventStatus: "Event Status",
    driver_performance_riskTab_driverDisputed: "Driver Disputed",
    driver_performance_riskTab_clickEvent: "Click on an event from the list to view details",
    driver_performance_riskTab_selectACategoryToViewEvents: "Select a category to view events",
    driver_performance_riskTab_comments: "Comments",
    driver_performance_riskTab_noCommentsAvailableForThisEvent: "No comments available for this event",
    driver_performance_riskTab_selectAnEventToViewComments: "Select an event to view comments",
    driver_performance_riskTab_addComment: "Add Comment",
}
